import React, { FC } from 'react';
import { BasketSelectSectionProps } from '@components/v2/BasketSelectSection';

const BasketSelectSectionTemplate: FC<BasketSelectSectionProps> = ({
    onClick,
    leftValue,
    rightValue,
    className,
    leftSelected,
    rightSelected,
    leftSectionTitle,
    leftSectionDescription,
    rightSectionTitle,
    rightSectionDescription,
}) => {
    return (
        <div className={className}>
            <div className="sections">
                {leftValue && (
                    <button
                        className={`leftSection ${leftSelected ? 'selected' : ''}`}
                        onClick={() => onClick(leftValue)}
                        data-testid={`TESTING_SELECTION_${leftValue?.toUpperCase()}`}
                    >
                        <div className="inner">
                            <span className="title">
                                <span className={`icon ${leftSelected ? 'selected' : ''}`}>
                                    <span className={leftSelected ? 'selected' : ''} />
                                </span>{' '}
                                {leftSectionTitle}
                            </span>
                            <span className="description">{leftSectionDescription}</span>
                        </div>
                    </button>
                )}
                {rightValue && (
                    <button
                        className={`rightSection ${rightSelected ? 'selected' : ''}`}
                        onClick={() => onClick(rightValue)}
                        data-testid={`TESTING_SELECTION_${rightValue?.toUpperCase()}`}
                    >
                        <div className="inner">
                            <span className="title">
                                <span className={`icon ${rightSelected ? 'selected' : ''}`}>
                                    <span className={rightSelected ? 'selected' : ''} />
                                </span>{' '}
                                {rightSectionTitle}
                            </span>
                            <span className="description">{rightSectionDescription}</span>
                        </div>
                    </button>
                )}
            </div>
        </div>
    );
};

export default BasketSelectSectionTemplate;
